import React from "react";
import Header from "../components/pages/landing/Header";
import Hero from "../components/pages/landing/HeroSection";
import Services from "../components/pages/landing/Services";
import Stats from "../components/pages/landing/Stats";
import OurWorkAndClients from "../components/pages/landing/OurWorkAndClients";
import ClientsReview from "../components/pages/landing/ClientsReview";
import Contact from "../components/pages/landing/Contact";
import Footer from "../components/pages/landing/Footer";

function Home() {
  return (
    <div>
      <Header />
      <Hero />
      <Stats />
      <Services />
      <OurWorkAndClients />
      <ClientsReview />
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;
